'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 4.06503e-05C0 4.06503e-05 0.895431 3.17692e-05 2 3.17692e-05C10.6667 3.17692e-05 19.3333 -4.53078e-05 28 4.06503e-05V20C18.6667 20 9.33333 20 0 20V4.06503e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#DC1F37" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3335 10C17.3335 8.00002 17.3335 6.66669 17.3335 6.66669H22.6668C22.6668 6.66669 22.6668 8.00002 22.6668 10C22.6668 12 20.0002 13.3334 20.0002 13.3334C20.0002 13.3334 17.3335 12 17.3335 10Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.0003 12C20.7367 12 21.3337 11.4031 21.3337 10.6667C21.3337 9.93033 20.7367 9.33337 20.0003 9.33337C19.2639 9.33337 18.667 9.93033 18.667 10.6667C18.667 11.4031 19.2639 12 20.0003 12Z",
          fill: "#65B5D2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.0003 9.33337C20.3685 9.33337 20.6668 9.03486 20.6668 8.66667C20.6668 8.29848 20.3684 8 20.0002 8C19.632 8 19.3335 8.29848 19.3335 8.66667C19.3335 9.03486 19.6321 9.33337 20.0003 9.33337Z",
          fill: "#E20B0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.667 10.6667C19.0352 10.6667 19.3333 10.3682 19.3333 9.99998C19.3333 9.63179 19.0349 9.33331 18.6667 9.33331C18.2985 9.33331 18 9.63179 18 9.99998C18 10.3682 18.2988 10.6667 18.667 10.6667Z",
          fill: "#E20B0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.9998 9.99998C21.9998 10.3682 21.7019 10.6667 21.3337 10.6667C20.9655 10.6667 20.6665 10.3682 20.6665 9.99998C20.6665 9.63179 20.965 9.33331 21.3332 9.33331C21.7014 9.33331 21.9998 9.63179 21.9998 9.99998Z",
          fill: "#E20B0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.7628 12C20.9894 12.8387 20.0001 13.3334 20.0001 13.3334C20.0001 13.3334 19.0108 12.8387 18.2373 12H21.7628Z",
          fill: "#2F8F22"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagBmAsset = forwardRef(FlagBmAsset);

export { VpFlagBmAsset as default };
